import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { KeycloakService } from "keycloak-angular";
import { Subject } from "rxjs";
import { environment } from 'src/environments/environment';
@Injectable()
export class UserService {

  user: any;
  userChange: Subject<any> = new Subject<any>();

  constructor(private keycloakService: KeycloakService, private router: Router,
    private translate: TranslateService) {
    this.getUser();
  }

  async setUser() {

    let keycloakService = this.keycloakService;
    await keycloakService.isLoggedIn().then(async logged => {
      if (logged) {
        await keycloakService.loadUserProfile(true).then(async response => {

          this.user = response;
          this.user.roles = this.keycloakService.getUserRoles(false);
          this.user.isAdmin = this.user.roles.some(p => p == 'admin') || this.user.roles.some(p => p == 'merchant-admin');
          this.user.isOwner = this.user.roles.some(p => p == 'owner') || this.user.roles.some(p => p == 'merchant-owner');
          this.user.isViewerOwner = this.user.roles.some(p => p == 'viewer') || this.user.roles.some(p => p == 'merchant-viewer') && this.user.roles.some(p => p == 'owner') || this.user.roles.some(p => p == 'merchant-owner');
          this.user.isViewer = this.user.roles.some(p => p == 'viewer') || this.user.roles.some(p => p == 'merchant-viewer');
          this.user.isFinanceSpecialist = this.user.roles.some(p => p == 'finance-specialist') || this.user.roles.some(p => p == 'merchant-finance-specialist');;
          this.user.isFinanceAnalyst = this.user.roles.some(p => p == 'finance-analyst') || this.user.roles.some(p => p == 'merchant-finance-analyst');;
          this.user.isTiSpecialist = this.user.roles.some(p => p == 'it-specialist');
          this.user.isSales = this.user.roles.some(p => p == 'sales');
          this.user.isSupportMerchant = this.user.roles.some(p => p == 'support-merchant');
          this.user.isTuna = this.user.roles.some(p => p == 'tuna');
          this.user.isUserTuna = this.user.username.includes('@tuna');

          if (response['attributes'].partnerMerchantKeys) {
            this.user.merchantKeys = response['attributes'].partnerMerchantKeys;
          }

          if (response['attributes'].theme) {
            this.user.theme = response['attributes'].theme;
          }

          let instanceKeycloak = keycloakService.getKeycloakInstance();

          await instanceKeycloak.loadUserInfo().then(responseLoadUser => {

            let realm = instanceKeycloak.realm;

            this.setPortal(realm, response['attributes']);
            let featuresGeral = environment.features[sessionStorage.getItem('portal')] as Array<any>;

            if (responseLoadUser["tuna"]) {
              if (responseLoadUser["tuna"].features) {


                let features_partner = responseLoadUser["tuna"].features.partner;


                let features_in_console = [];

                if (responseLoadUser["tuna"].features.user)
                  features_in_console = features_in_console.concat(responseLoadUser["tuna"].features.user[0]);

                features_in_console = features_in_console.concat(features_partner);

                features_in_console.forEach((element: any) => {

                  if (element) {
                    let parts = element.split(":"); //separar a chave por :
                    let part0 = parts[0].split(','); // separar a primeira parar para caso tenha disable

                    let disable = false;

                    if (part0.length > 1) {
                      disable = part0[1] == "disable"; // sendo após a ',' disable, precisa assim desabilitar a feature
                    }

                    if (disable) {

                      if (parts.length == 2) { // desabilita tudo da feature

                        if (featuresGeral.find(p => p.key == parts[1])) {  // urn,disable:flows, se a chave inclui a string
                          featuresGeral.find(p => p.key == parts[1]).enabled = false;

                          let subfeatures = featuresGeral.find(p => p.key == parts[1]).subfeatures;
                          subfeatures.forEach(sub => {
                            sub.enabled = false;
                          });
                        }
                      }
                      else {
                        if (parts.length == 3) { //desabilitar somente a subfeature
                          if (featuresGeral.find(p => p.key == parts[1])) {
                            let subfeatures = featuresGeral.find(p => p.key == parts[1]).subfeatures;
                            subfeatures.forEach(sub => {
                              if (sub.key == parts[2]) {
                                sub.enabled = false;
                              }
                            });
                          }
                        }
                      }

                    } else { //habilitando uma versão, ex urn:merchant:v1
                      if (parts.length == 3) {
                        let part1 = parts[1].split(',');

                        if (featuresGeral.filter(p => p.key == part1[0]).length > 0) {

                          featuresGeral.filter(p => p.key == part1[0]).forEach(element => {
                            element.current_version = parts[2];
                            element.enabled = true;


                            if (part1.length > 1)
                              element.subfeatures.forEach(ab => {
                                if (ab.key == parts[1]) {
                                  ab.current_version = parts[2];
                                  ab.enabled = true;
                                }
                              });
                          });
                        }


                      } else {
                        if (parts.length == 4) { //habilitando uma versão da subfeature, ex urn:merchant:create:v1
                          let subfeatures = featuresGeral.find(p => p.key == parts[1]).subfeatures;
                          subfeatures.forEach(sub => {
                            sub.current_version = parts[3];
                            sub.enabled = true;

                          });
                        }
                      }
                    }
                  }
                });
              }
            }

            //verificando roles
            featuresGeral.forEach((feature) => {
              if (feature.enabled) {

                if (feature.roles) {
                  if (!this.user.roles.find(p => p == feature.roles.find(a => a == p))) {
                    feature.enabled = false;
                  }
                  else {
                    feature.enabled = true;
                  }

                  if (feature.subfeatures) {
                    if (feature.subfeatures.length > 0) {
                      feature.subfeatures.forEach((sub) => {
                        if (sub.roles) {
                          if (sub.enabled) {
                            if (!this.user.roles.find(p => p == sub.roles.find(a => a == p))) {
                              sub.enabled = false;
                            } else {
                              sub.enabled = true;
                            }
                          }
                        }
                      });
                    }
                  }
                }
              }

            });



            this.user.features = featuresGeral;

            this.user.partnerSeeConnections = this.user.features.find(p => p.key == "connections")?.enabled;
            this.user.partnerSeeMerchant = this.user.features.find(p => p.key == "merchants")?.enabled;
            this.user.partnerSeeLink = this.user.features.find(p => p.key == "link")?.enabled;
            this.user.partnerSeeFlows = this.user.features.find(p => p.key == "flow")?.enabled;

            // if (features_partner) {
            //     features_in_partner = environment.features ? features_partner.filter(p => environment.features.find(x => x.key == p)) : '';
            // }

            // if (features_user)
            //     features_in_user = environment.features ? features_user.filter(p => environment.features.find(x => x.key == p)) : '';

            // if (features_in_partner) {
            //     if (features_in_partner.length > 0)
            //         this.user.features = features_in_partner
            // }

            // if (features_in_user) {
            //     if (features_in_user.length > 0)
            //         this.user.features = features_in_user;
            // }

            localStorage['theme'] = this.user.theme;

            if (this.router.url.includes('/tuna')) {
              localStorage['user-console-tuna'] = JSON.stringify(this.user);
              this.userChange.next(this.user);
            }
            else {
              localStorage['user-tuna'] = JSON.stringify(this.user);
              this.userChange.next(this.user);
            }

            if (response['attributes'].locale) {
              let locale = response['attributes'].locale[0].toLocaleLowerCase();;

              const langToSet = 'pt-br';
              const browserCultureLang = this.translate.getBrowserCultureLang().toLocaleLowerCase();

              if (locale == 'en' || locale == 'ens')
                locale = 'en-us';

              this.translate.use(locale ? locale : (browserCultureLang.match(/pt-br|es-es|en-us/) ? browserCultureLang : langToSet));
            } else {
              this.translate.use('pt-br');
            }

            return this.user;
          });
        });
      } else {
        this.removeUser();
      }
    });
  }

  getUser() {
    if (this.router.url.includes('/tuna')) {
      if (localStorage['user-console-tuna']) {
        this.user = JSON.parse(localStorage['user-console-tuna']);
        this.user.portal = sessionStorage.getItem('portal');
        this.userChange.next(this.user);
        return this.user;
      }
      this.removeUser();
    } else {
      if (localStorage['user-tuna']) {
        this.user = JSON.parse(localStorage['user-tuna']);
        this.user.portal = sessionStorage.getItem('portal');
        this.userChange.next(this.user);
        return this.user;
      }
      this.removeUser();
    }
  }

  getUserRoles() {
    return this.user.roles;
  }

  getUserPermissions() {
    return {
      isAdmin: this.user.isAdmin,
      isOwner: this.user.isOwner,
      isViewerOwner: this.user.isViewerOwner,
      isViewer: this.user.isViewer,
      isFinanceSpecialist: this.user.isFinanceSpecialist,
      isFinanceAnalyst: this.user.isFinanceAnalyst,
      isTiSpecialist: this.user.isTiSpecialist,
      isSales: this.user.isSales,
      isSupportMerchant: this.user.isSupportMerchant,
      isTuna: this.user.isTuna,
      partnerSeeMerchant: this.user.partnerSeeMerchant,
      partnerSeeConnections: this.user.partnerSeeConnections,
      partnerSeeLink: this.user.partnerSeeLink,
      partnerSeeFlows: this.user.partnerSeeFlows
    }
  }

  getFeatures(features) {
    return this.user.features.find(p => p.key == features).subfeatures;
  }

  removeUser() {

    if (this.router.url.includes('/tuna')) {
      localStorage.removeItem('user-console-tuna');
      sessionStorage.removeItem('portal');
      this.user = null;
      this.userChange.next(this.user);
    } else {
      localStorage.removeItem('user-tuna');
      sessionStorage.removeItem('portal');
      this.user = null;
      this.userChange.next(this.user);
    }
  }

  setPortal(realm, attributes) {
    if (realm == 'tuna') {
      sessionStorage.setItem('portal', 'tuna');
    } else {
      let merchant = attributes.partnerMerchantKeys;
      const portal = merchant ? 'merchant' : 'console';
      sessionStorage.setItem('portal', portal);
    }
  }
}
